
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1201_RecvDialog extends Serenity.Extensions.GridEditorDialog<Report_1201_RecvRow> {
        protected getFormKey() { return Report_1201_RecvForm.formKey; }
        // protected getIdProperty() { return Report_1201_RecvRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1201_RecvRow.localTextPrefix; }
        protected getNameProperty() { return Report_1201_RecvRow.nameProperty; }
        // protected getService() { return Report_1201_RecvService.baseUrl; }
        // protected getDeletePermission() { return Report_1201_RecvRow.deletePermission; }
        // protected getInsertPermission() { return Report_1201_RecvRow.insertPermission; }
        // protected getUpdatePermission() { return Report_1201_RecvRow.updatePermission; }

        protected form = new Report_1201_RecvForm(this.idPrefix);
        // constructor() {
        //     super();

        //     this.form = new Report_1201_RecvForm(this.idPrefix);
        // }
    }
}